import type { InjectedRouter } from 'react-router';
import { MenuItem } from 'react-bootstrap';
import type React from 'react';
import { containEvent } from '../../utils';

type MenuItemLinkProps = {
  /**
   * Event key for push (should be a valid route uri)
   */
  eventKey: string;
  /**
   * router.push - use to navigate to a new route
   */
  routerPush: InjectedRouter['push'];
};

/**
 * A wrapper with better link handling for MenuItem.
 * This component will provide a href for accessibility and correctly override the href with a router push.
 */
const MenuItemLink: React.FunctionComponent<MenuItemLinkProps> = ({ eventKey, routerPush, children }) => {
  const route = containEvent(() => {
    routerPush(eventKey);
    return false;
  });

  return (
    <MenuItem eventKey={eventKey} onClick={route} href={eventKey}>
      {children}
    </MenuItem>
  );
};

export default MenuItemLink;
